import EventEmitter from 'eventemitter3';

export default class Menu extends EventEmitter {
    expanded = false;

    setup() {
        this.menu = document.querySelector('[data-menu]');
        this.content = document.querySelector('[data-menu-content]');
        const button = document.querySelector('[data-menu-toggle]');

        button.addEventListener('click', () => {
            if(!this.expanded) {
                this.open();
            } else {
                this.close();
            }
        });
    }

    close() {
        this.expanded = false;
        this.menu.classList.remove('menu--expanded');
        this.content.classList.remove('menu__content--expanded');
        this.emit('closed');
    }

    open() {
        this.expanded = true;
        this.menu.classList.add('menu--expanded');
        this.content.classList.add('menu__content--expanded');
        this.emit('opened');
    }
}
